<template>
  <b-row class="mb-1">
    <b-col cols="12" class="mb-2">
      <h2>{{ $t('Custom Dashboards (Beta)') }}</h2>
    </b-col>
    <b-col cols="12">
      <AddDashboardButton class="mb-2"/>
      <b-table
        :items="dashboards"
        :fields="fields"
        bordered
        striped
        responsive
        head-variant="light"
      >
        <template #cell(name)="data">
          <router-link
            :to="{ name: 'dashboard', params: { id: data.item.id } }"
          >
            {{ data.item.name }}
          </router-link>
        </template>
        <template #cell(actions)="data">
          <DashboardActions :name="data.item.name" :deleteUrl="deleteDashboardUrl(data.item.id)" />
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import AddDashboardButton from '@/xvisor/components/custom/AddDashboardButton.vue';
import DashboardActions from '@/xvisor/components/custom/DashboardActions.vue';
import DashboardEventBus from '@/xvisor/bus/DashboardEventBus';

export default ({
  components: {
    AddDashboardButton,
    DashboardActions,
  },
  data() {
    return {
      dashboards: [],
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'actions', label: '', class: 'text-center' },
      ],
    };
  },
  methods: {
    httpGet() {
      this.$http
        .get('/dashboards/list.json')
        .then((response) => { this.dashboards = response.data; });
    },
    deleteDashboardUrl(dashboardId) {
      return `/dashboards/${dashboardId}`;
    },
  },
  mounted() {
    DashboardEventBus.$on('added', this.httpGet);
    DashboardEventBus.$on('deleted', this.httpGet);
    this.httpGet();
  },
});
</script>
